
import { axios } from '@/utils/request'
import { sysInfo } from '@/config'

export function insertDesigns (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/design',
    method: 'POST',
    data: parameter
  })
}
export function updateDesigns (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/design',
    method: 'POST',
    data: parameter
  })
}
export function deleteDesigns (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/designs' + parameter,
    method: 'DELETE'
  })
}
export function getDesignList (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/designs',
    method: 'GET',
    params: parameter
  })
}
export function getDesignsInfo (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/designs',
    method: 'GET',
    params: parameter
  })
}
// 修改业主状态
export function modifyDesignStatus (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/design',
    method: 'PUT',
    data: parameter
  })
}
